import { t } from "@lingui/macro";
import { useAtomValue, useSetAtom } from "jotai";

import { ReloadIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { getBookingPlayerNoun } from "../../../../../../../../../../BookingSummary/utils/getBookingPlayerNoun";
import { enterReplacePlayerStepAtom } from "../../../../../../../../../atoms/actions/enterReplacePlayerStepAtom/enterReplacePlayerStepAtom";
import { currentBookingAtom } from "../../../../../../../../../atoms/stores";

export const SwapPlayerMenuItem = ({
  roundId,
  closeMenu,
}: {
  roundId: string;
  closeMenu: () => void;
}) => {
  const enterReplacePlayerStep = useSetAtom(enterReplacePlayerStepAtom);
  const currentBooking = useAtomValue(currentBookingAtom);
  const playerNoun = getBookingPlayerNoun({
    bookingType: currentBooking?.type,
    copyOverrides: currentBooking?.copyOverrides,
  });

  return (
    <Pressable
      onPress={() => {
        enterReplacePlayerStep({ roundId });
        closeMenu();
      }}
    >
      <HStack gap={3} paddingHorizontal={4} paddingVertical={3}>
        <ReloadIcon />
        <Text>{t`Replace ${playerNoun.singular}`}</Text>
      </HStack>
    </Pressable>
  );
};
